import {t} from 'i18next';
import {Button} from 'primereact/button';
import {Messages} from 'primereact/messages';
import queryString from 'query-string';
import React from 'react';
import {Link} from 'react-router-dom';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import InputPasswordComponent from '../../components/inputs/InputPasswordComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import SimpleReactValidator from '../../components/validator';
import BlockUi from '../../components/waitPanel/BlockUi';
import i18n from '../../i18n';
import AccountService from '../../services/AccountService';
import RegisterService from '../../services/RegistrationService';
import StringUtils from '../../utils/StringUtils';
import ActionButton from '../../components/ActionButton';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import {Card} from 'primereact';
import InputCheckboxComponent from '../../components/inputs/InputCheckboxComponent';

class AbstractConfirmPasswordContainer extends BaseDetailsContainer {
    // ABSTRACT METHODS
    getPasswordParams = () => {};
    getService = () => new AccountService();
    handleCorrectPasswordToken = (wsRes) => {};
    handleErrorPasswordToken = (wsErr) => {};
    handleCorrectPasswordChange = (wsRes) => {};
    renderDetail = () => {};

    constructor(props) {
        super(props);
        this.handleChangeOpt = this.handleChangeOpt.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.state = {
            element: {
                approval: [],
            },
            newPassword: '',
            repeatPassword: '',
            agreements: [],
            agreementsAccepted: {},
            maxLength: 15,
            minLength: 5,
            lowerCaseCount: 3,
            upperCaseCount: 4,
            numbersCount: 0,
            specialCharactersCount: 0,
            status: '',
        };
        this.registrationService = new RegisterService();
        this.validator = new SimpleReactValidator({}, this.translate);
        this.afterPreLogoutUser = this.afterPreLogoutUser.bind(this);
        this.scrollToTopOnMount = false;
    }

    afterPreLogoutUser() {
        this.blockUi();
        this.getPasswordParams();
        const token = queryString.parse(this.props.location?.search)?.token;
        const tokenType = this.props.type === 'CREATE' ? 'USER_REGISTER' : 'PASSWORD_RECOVERY';
        this.blockUi();
        this.getService().checkToken(token, tokenType).then(this.handleCorrectPasswordToken).catch(this.handleCorrectPasswordToken);
        this.getService()
            .getLanguageFromToken(token, tokenType)
            .then((resp) => {
                if (resp && resp.agreements instanceof Array) {
                    const accepted = {};
                    resp.agreements.forEach((a) => {
                        if (a && a.id !== undefined && a.id !== null) {
                            accepted[a.id] = false;
                        }
                    });
                    this.setState({agreements: resp.agreements, agreementsAccepted: accepted});
                }
                if (!StringUtils.isBlank(resp.language) && window.localStorage.getItem('i18nextLng') !== resp.language) {
                    window.localStorage.setItem('i18nextLng', resp.language);
                    sessionStorage.setItem('i18nextLng', resp.language);
                    i18n.changeLanguage(resp.language);
                }
                this.unblockUi();
            })
            .catch((err) => this.unblockUi());
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.handlePreLogoutUser(this.afterPreLogoutUser);
        this.initBeforeSetElement();
    }

    handleChangeOpt(e) {
        console.log(e);
        this.setState({
            [e.target.name]: e.target.value,
        });
    }

    handleFormSubmit(e) {
        if (e) {
            e.preventDefault();
        }
        if (this.validator.allValid()) {
            const values = queryString.parse(this.props.location.search);
            const body = {newPassword: this.state.newPassword};
            if (this.props.type === 'CREATE' && this.state.agreements && this.state.agreements.length > 0) {
                const acceptedAgreements = Object.entries(this.state.agreementsAccepted || {})
                    .filter(([, v]) => v)
                    .map(([k]) => (isNaN(k) ? k : Number(k)));
                body.acceptedAgreements = acceptedAgreements;
            }
            const token = values.token;
            const tokenType = this.props.type === 'CREATE' ? 'USER_REGISTER' : 'PASSWORD_RECOVERY';
            this.getService()
                .setPassword(token, tokenType, body)
                .then(this.handleCorrectPasswordChange)
                .catch((err) => {
                    this.messages.show({
                        closable: false,
                        life: 30000,
                        severity: 'error',
                        summary: 'Błąd',
                        detail: err.message,
                    });
                });
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.setState({
                valid: false,
            });
            this.forceUpdate();
        }
    }

    render() {
        return (
            <React.Fragment>
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    <div id='main-login'>
                        <Messages id='custom-messages' ref={(el) => (this.messages = el)} />
                        <div className='container'>
                            <div className='row'>
                                <div className='col-sm-10 col-md-8 col-lg-5 mx-auto'>
                                    <div className='card card-signin my-5'>{this.renderDetail()}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }
    translate(key) {
        return t(key);
    }
    renderForm = () => {
        return (
            <Card className='details-card'>
                <h5 className='card-title '>
                    {this.props.type && this.props.type === 'CREATE' ? (
                        <label className='before-login-title mb-4 d-flex justify-content-center'>
                            {this.translate('account.setNewPasswordLabel')}
                        </label>
                    ) : (
                        <label className='before-login-title mb-4 d-flex justify-content-center'>
                            {this.translate('account.resetPasswordLabel')}{' '}
                        </label>
                    )}
                </h5>
                <div className='p-4'>
                    <form
                        className=''
                        onSubmit={(e) => {
                            this.handleFormSubmit(e);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                this.handleFormSubmit();
                            }
                        }}
                        //avoid setting red border just after the page has loaded (red border because of undefined required value in FF)
                        noValidate
                    >
                        {/* <div className="form-group"></div> */}
                        {/* <div className="form-group"> */}
                        <div className='row '>
                            <InputTextComponent
                                id='email'
                                name='email'
                                label={this.translate('user.email')}
                                classLabel='black-label'
                                value={this.state.email}
                                onChange={(a, b, c) => this.handleChangeOpt(c)}
                                className={this.state.email ? 'form-control' : 'form-control invalid'}
                                type='text'
                                validators='required|email'
                                validator={this.validator}
                                viewMode='VIEW'
                                colClass='col-xl-12 col-lg-12 col-md-12 col-sm-12'
                            />
                            <div className='col-12 mt-2 mb-2'>
                                <label>{this.getPasswordLabel()}</label>
                            </div>
                            <InputPasswordComponent
                                id='newPassword'
                                // eslint-disable-next-line max-len
                                //label={this.getPasswordLabel()}
                                label={this.translate('password.newPassword')}
                                classLabel='black-label'
                                labelForValidator={this.translate('password.newPassword')}
                                name='newPassword'
                                value={this.state.newPassword}
                                validator={this.validator}
                                onChange={(a, b, c) => this.handleChangeOpt(c)}
                                viewMode='EDIT'
                                validators={`required|extended_password:${this.state.minLength}:${this.state.maxLength}:${this.state.lowerCaseCount}:${this.state.upperCaseCount}:${this.state.numbersCount}:${this.state.specialCharactersCount}`}
                                colClass='col-12'
                                classInput={'black-label'}
                            />
                            <InputPasswordComponent
                                id='repeatPassword'
                                label={this.translate('password.repeatNewPassword')}
                                name='repeatPassword'
                                classLabel='black-label'
                                value={this.state.repeatPassword}
                                feedback={false}
                                validator={this.validator}
                                onChange={(a, b, c) => this.handleChangeOpt(c)}
                                viewMode='EDIT'
                                validators={`required|equals_encoded:${encodeURIComponent(this.state.newPassword)},${this.translate('password.newPassword')}`}
                                colClass='col-12'
                                classInput={'black-label'}
                            />
                            {this.props.type === 'CREATE' && this.state.agreements && this.state.agreements.length > 0 ? (
                                <div className='col-12 mt-3'>
                                    <p className='text-muted small mb-2'>
                                        Przed nadaniem hasła zapoznaj się z poniższymi dokumentami i potwierdź ich akceptację.
                                        Zaznaczenie pól oznacza, że akceptujesz treść dokumentów i zobowiązujesz się do ich przestrzegania.
                                    </p>
                                    {this.state.agreements.map((ag) => (
                                        <InputCheckboxComponent
                                            key={`agreement-${ag.id}`}
                                            id={`agreement-${ag.id}`}
                                            name={`agreement-${ag.id}`}
                                            labelOnRight
                                            renderRequired
                                            renderLink={ag.url}
                                            label={ag.title || ag.name}
                                            validator={this.validator}
                                            validators='required|boolean'
                                            value={!!this.state.agreementsAccepted?.[ag.id]}
                                            onChange={(type, params, e) => {
                                                const checked = e.checked;
                                                this.setState((prev) => ({
                                                    agreementsAccepted: {
                                                        ...prev.agreementsAccepted,
                                                        [ag.id]: checked,
                                                    },
                                                }));
                                            }}
                                            viewMode='NEW'
                                            colClass='col-12 mb-2'
                                        />
                                    ))}
                                </div>
                            ) : null}
                        </div>
                        <ActionButton
                            label={t('password.save')}
                            variant='login-button all-width-button mt-4  justify-content-center'
                            handleClick={this.handleFormSubmit}
                            disabled={
                                this.state.captchaPreventAction ||
                                (this.props.type === 'CREATE' && this.state.agreements && this.state.agreements.length > 0
                                    ? !this.state.agreements.every((a) => this.state.agreementsAccepted?.[a.id])
                                    : false)
                            }
                        />
                        <ActionButton
                            label={t('details.cancel')}
                            variant='centered-button all-width-button gray mt-3 justify-content-center'
                            href={AppPrefixUtils.locationHrefUrl('/login')}
                            disabled={this.state.captchaPreventAction}
                        />
                    </form>
                </div>
            </Card>
        );
    };

    getPasswordLabel() {
        let message = this.translate('validator.extended_password');
        message = message.replace(':attribute', this.translate('password.newPassword'));
        message = message.replace(':min', this.state.minLength);
        message = message.replace(':max', this.state.maxLength);
        message = message.replace(
            ':lower',
            this.props.lang === 'pl'
                ? this.validator.declination(this.state.lowerCaseCount, 2)
                : this.validator.enDeclination(this.state.lowerCaseCount, 2)
        );
        message = message.replace(
            ':upper',
            this.props.lang === 'pl'
                ? this.validator.declination(this.state.upperCaseCount, 3)
                : this.validator.enDeclination(this.state.upperCaseCount, 3)
        );
        message = message.replace(
            ':number',
            this.props.lang === 'pl'
                ? this.validator.declination(this.state.numbersCount, 4)
                : this.validator.enDeclination(this.state.numbersCount, 4)
        );
        message = message.replace(
            ':special',
            this.props.lang === 'pl'
                ? this.validator.declination(this.state.specialCharactersCount, 5)
                : this.validator.enDeclination(this.state.specialCharactersCount, 5)
        );
        return message;
    }
}
export default AbstractConfirmPasswordContainer;
